import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from '@barges/react';
import classes from './classes.module.scss';

function AdvisorNotProvideServicesPopup({
  onCloseCliked,
  advisorNotProvideServicesPopupData,
  setAdvisorNotProvideServicesPopupData,
  makeChangeLanguage
}) {
  const { t } = useTranslation();

  const onAdvisorNotProvideServicesPopupContinueReadingClick = useCallback(() => {
    onCloseCliked();
    setAdvisorNotProvideServicesPopupData({});
  }, []);

  const advisorNotProvideServicesPopupExploreOthersClick = (e) => {
    makeChangeLanguage({ target: e.target, lang: advisorNotProvideServicesPopupData.lang });
  };

  const renderAdvisorNotProvideServicesPopup = () => {
    const advisorNotProvideServicesPopupDataShow = !!advisorNotProvideServicesPopupData.show;
    if (!advisorNotProvideServicesPopupDataShow) return null;
    return (
      <Popover
        isOpen={ advisorNotProvideServicesPopupDataShow }
        centered
        className="advisor-not-provide-services-popup"
      >
        <div className={ classes.advisorNotProvideServicesPopupContainer }>
          <div className={ classes.advisorNotProvideServicesPopupTitle }>
            {t('change_language.the_advisor_doesnt_provide_services')}
          </div>
          <div className={ classes.advisorNotProvideServicesPopupBody }>
            {t('change_language.this_advisor_does_not_support')}
          </div>
          <div className={ classes.advisorNotProvideServicesPopupButtonsContainer }>
            <div className={ classes.advisorNotProvideServicesPopupButtonContainer }>
              <button type="button" className={ classes.advisorNotProvideServicesPopupContinueReadingButton } onClick={ onAdvisorNotProvideServicesPopupContinueReadingClick }>
                { t('change_language.continue_reading') }
              </button>
            </div>
            <div className={ classes.advisorNotProvideServicesPopupButtonContainer }>
              <button type="button" className={ classes.advisorNotProvideServicesPopupExploreOthersButton } onClick={ advisorNotProvideServicesPopupExploreOthersClick }>
                { t('change_language.explore_others') }
              </button>
            </div>
          </div>
        </div>
      </Popover>
    );
  };

  return renderAdvisorNotProvideServicesPopup();
}

export default AdvisorNotProvideServicesPopup;
